//ヘッダー固定
$(window).scroll(function() {
    if ($(window).scrollTop() > 200) {
        $('header, .openbtn').addClass('fixed');
    } else {
        $('header, .openbtn').removeClass('fixed');
    }
});


/*

$(function() {
    $('.is-white').on('click', function() {
        $(this).addClass('is-active');
        $('.panel-item-white').addClass('is-active');
            $('.panel-item-black').removeClass('is-active');

    });

        $('.is-black').on('click', function() {
        $(this).addClass('is-active');
        $('is-white').removeClass('is-active');

        $('.panel-item-black').addClass('is-active');
    $('.panel-item-white').removeClass('is-active');
    });
});

*/


//グローバル メガメニュー
$(function() {
    $('.global .has-child').hover(function() { //hoverしたら
        $(this).addClass('active'); //「active」クラスを加える
        $(".sub-menu").addClass("active");
    }, function() {
        $(this).removeClass('active'); //「active」クラスを外す
        $(".sub-menu").removeClass("active");
    });
});

$(function() {
    $('.btn-close').on('click', function() {
        $('.sub-menu').removeClass("active");
    });
});


// ハンバーガーメニュー
$(".openbtn").click(function() {
    $(this).toggleClass('active');
    $("#g-nav").toggleClass('panelactive');
    $("header").toggleClass('posi');


});

$("#g-nav a").click(function() {
    $(".openbtn").removeClass('active');
    $("#g-nav").removeClass('panelactive');
    $("header").removeClass('posi');

});

//　アコーディオン
$(function() {
    $('.sp-accd dd').hide();
    $('.sp-accd dt').click(function() {
        $(this).toggleClass("active");
        $(this).next(".sp-accd dd").slideToggle();
    });
});